import zod from 'zod';
import { stringToBoolean, stringToListOfEnum, stringToListOfNumber } from './helpers';
import { occurrencePriorities, triggerTypes } from './dispatch';

const EventsOccurrenceDetailSchema = zod.object({
    occurrenceId: zod.coerce.number().optional(),
});

const EventsBoardSchema = zod.object({
    beginIn: zod.coerce.number().optional(),
    endIn: zod.coerce.number().optional(),
    tags: stringToListOfNumber.optional(),
    actingBodyId: zod.coerce.number().optional(),
    occurrenceTypeId: zod.coerce.number().optional(),
    withDispatch: stringToBoolean.optional(),
    withoutDispatch: stringToBoolean.optional(),
    mapPolygonIds: stringToListOfNumber.optional(),
    polygonType: zod.string().optional(),
    triggerType: stringToListOfEnum(zod.enum([
        ...triggerTypes,
        'manual',
    ])).optional(),
    priority: zod.enum(occurrencePriorities).optional(),
});

export const EventsSchemas = {
    EventsOccurrenceDetail: EventsOccurrenceDetailSchema,
    EventsBoard: EventsBoardSchema,
};
